import plate from '../images/plate.png';
import square from '../images/square.png';
import c from '../images/C.png';
import angle from '../images/angle.png';
import { InputVariable } from "../App";

export type ShapeProps = {
    Name: string;
    Abreviation: string;
    UniqueDimensions: InputVariable[];
    Image: string;
}
export type ShapeList ={
    Shapes: ShapeProps[];
}

export const Sheet:ShapeProps ={ // currently not being used
    Name: "Sheet/Plate",
    Abreviation: "PL",
    UniqueDimensions:[
        "W","t"
    ],
    Image: plate
}
export const CChannel:ShapeProps ={
    Name: "C-Channel",
    Abreviation: "C",
    UniqueDimensions:[
        "d", "W"
    ],
    Image: c
}
export const SquarePipe:ShapeProps ={
    Name: "Square Tubing",
    Abreviation: "HSS",
    UniqueDimensions:[
        "Ht", "B", "tnom"
    ],
    Image: square
}
export const AngleL:ShapeProps ={
    Name: "Angle (L)",
    Abreviation: "L",
    UniqueDimensions:[
        "b", "d", "t"
    ],
    Image: angle
}
export const Angle2L:ShapeProps ={
    Name: "Angle (2L)",
    Abreviation: "2L",
    UniqueDimensions:[
        "b", "d", "t"
    ],
    Image: angle
}

export const Geometry: ShapeList ={
    Shapes:[
        Sheet,SquarePipe, CChannel, AngleL, Angle2L
    ]
}

// metals below

export type MetalProps ={
    Name: string;
    Density: number;
}
export type MaterialList ={
    Metals:MetalProps[]
}

export const Alumininum: MetalProps ={
    Name: "Pure Alumininum",
    Density: 2710 //kg per m^3
}
export const Iron: MetalProps ={
    Name: "Pure Iron",
    Density: 7860 //kg per m^3
}
export const CarbonSteelA36: MetalProps ={
    Name: "Carbon Steel",
    Density: 7850 // kg per m^3
}

export const Materials: MaterialList ={
    Metals:[
        CarbonSteelA36,
    ]
}

export type UnitList ={
    dimensional: Unit[];
}
export type Unit ={
    Name: string;
    DocConvert: string;
    Mass: string;
    SmallDimension: string;
    BigDimensions: string;
}
export const imperial: Unit ={
    Name: "Imperial",
    DocConvert:"",
    Mass: "lbs",
    SmallDimension: "in",
    BigDimensions: "ft"
}
export const metric: Unit ={
    Name: "Metric",
    DocConvert:"_1",
    Mass: "kg",
    SmallDimension: "mm",
    BigDimensions: "m" //?
}
export const AllUnits: UnitList ={
    dimensional:[
        imperial, metric
    ]
}
